import React, { useState, useEffect } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const Dropdown = ({ options, onSelect, defaultLabel }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    
    useEffect(() => {
        if (!selectedOption) {
            setSelectedOption({ label: defaultLabel, value: null });
        }
    }, [selectedOption, defaultLabel]);
    
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const selectOption = (option) => {
        setSelectedOption(option);
        onSelect(option.value); // Notify parent component of the selected value
        setIsOpen(false);
    };

    return (
        <div className="dropdown">
            <div className="dropdown-header" onClick={toggleDropdown}>
                {selectedOption ? selectedOption.label : defaultLabel}
                {isOpen ? <FaChevronUp style={{paddingTop: '4px' }} /> : <FaChevronDown style={{paddingTop: '4px' }} />}
            </div>
            {isOpen && (
                <div className="dropdown-options">
                    {options.map((option) => (
                        <div
                            key={option.value}
                            className={`dropdown-option ${selectedOption === option ? 'active' : ''}`}
                            onClick={() => selectOption(option)}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Dropdown;
